/**
 * Full-width banner shown when Apple Search Ads is unreachable (Apple-side
 * outage). Polls /api/asa-health; renders nothing while ASA is healthy.
 * Reassures the user it's an Apple outage, not their account — data is just
 * delayed and will catch up once ASA recovers.
 */

import { useAsaHealth } from "@/lib/api-hooks";

export function AsaHealthBanner() {
  const q = useAsaHealth();
  const h = q.data;
  if (!h?.degraded) return null;

  let since: string | null = null;
  if (h.since) {
    const d = new Date(h.since);
    if (!Number.isNaN(d.getTime())) {
      since = d.toLocaleString(undefined, {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      });
    }
  }

  return (
    <div
      role="status"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 60,
        background: "#fef3c7",
        color: "#92400e",
        borderBottom: "1px solid #f59e0b",
        padding: "9px 16px",
        fontSize: 13,
        fontWeight: 500,
        textAlign: "center",
        lineHeight: 1.4,
      }}
    >
      ⚠ Apple Search Ads is currently unreachable — spend &amp; metrics may be
      delayed{since ? ` (since ${since})` : ""}. This is an Apple-side outage,
      not your account; data will catch up automatically once it recovers.
    </div>
  );
}
